<template>
    <v-form>
        <v-container class="px-16">
            <v-row v-if="errorResponse !== null">
                <v-col>
                <v-alert
                        v-model="alert"
                        dense
                        class="multi-line"
                        type="error"
                        dismissible
                >{{ errorResponse.status }} : {{ errorResponse.statusText }}
                </v-alert>
                </v-col>
            </v-row>
            <v-row>
                <h2>
                    Backoffice Login
                </h2>
            </v-row>
            <v-row>
                <v-text-field
                        v-model="userName"
                        label="username"
                        required
                ></v-text-field>
            </v-row>
            <v-row>
                <v-text-field
                        v-model="password"
                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show ? 'text' : 'password'"
                        label="password"
                        @keyup.enter="login"
                        @click:append="show = !show"
                ></v-text-field>
            </v-row>
            <v-row>
                <v-spacer></v-spacer>
                <v-btn class="mr-3" @click="login">Login</v-btn>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
    import constants from "../constants";

    export default {
        name: "Login.vue",
        data: () => ({
            password: '',
            userName: '',
            show: false,
            errorResponse: null,
            alert: false
        }),
        methods: {
            login() {
                this.$http.post(constants.LOGIN_ENDPOINT, {}, {
                    auth: {
                        username: this.userName,
                        password: this.password
                    },
                    withCredentials: true
                })
                    .then(() => {
                        sessionStorage.setItem('loggedIn', 'true')
                        this.alert = false
                        this.$emit('login')
                    })
                    .catch(error => {
                        this.alert = true;
                        this.errorResponse = error;
                    });
            }
        }
    }
</script>

<style scoped>

</style>
